import _toConsumableArray from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CreatableSelect from 'react-select/lib/Creatable';
import uniq from 'lodash/uniq';
import './Multiselect.css';

var MultiSelect = /*#__PURE__*/function (_Component) {
  _inherits(MultiSelect, _Component);

  function MultiSelect() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MultiSelect);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MultiSelect)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      inputValue: ''
    }, _this.styles = {
      multiValue: function multiValue(provided, _ref) {
        var value = _ref.data.value;
        var validate = _this.props.validate;

        if (!validate) {
          return _extends({}, provided);
        }

        var valid = validate(value);
        var wrongStyle = valid ? {} : {
          backgroundColor: '#EC6661'
        };
        return _extends({}, provided, wrongStyle);
      },
      multiValueLabel: function multiValueLabel(provided, _ref2) {
        var value = _ref2.data.value;
        var validate = _this.props.validate;

        if (!validate) {
          return _extends({}, provided);
        }

        var valid = validate(value);
        var wrongStyle = valid ? {} : {
          color: '#ffffff'
        };
        return _extends({}, provided, wrongStyle);
      },
      multiValueRemove: function multiValueRemove(provided, _ref3) {
        var value = _ref3.data.value;
        var validate = _this.props.validate;
        var invalidRemoveButtonStyle = {
          color: '#F9D1CF',
          paddingLeft: '0px',
          paddingRight: '0px',
          ':hover': {
            color: '#ffffff',
            cursor: 'pointer'
          }
        };
        var standardRemoveButtonStyle = {
          color: '#888888',
          paddingLeft: '0px',
          paddingRight: '0px',
          ':hover': {
            color: '#333333',
            cursor: 'pointer'
          }
        };

        if (!validate) {
          return _extends({}, provided, standardRemoveButtonStyle);
        }

        var valid = validate(value);
        return _extends({}, provided, valid ? standardRemoveButtonStyle : invalidRemoveButtonStyle);
      }
    }, _this.handleChange = function (values) {
      var _this$props$input = _this.props.input;
      _this$props$input = _this$props$input === void 0 ? {} : _this$props$input;
      var onChange = _this$props$input.onChange;

      if (onChange) {
        onChange(values.map(function (value) {
          return value.value;
        }));
      }
    }, _this.handleInputChange = function (inputValue) {
      _this.setState({
        inputValue: inputValue
      });
    }, _this.handleBlur = function () {
      var inputValue = _this.state.inputValue;
      var _this$props$input2 = _this.props.input;
      _this$props$input2 = _this$props$input2 === void 0 ? {} : _this$props$input2;
      var _this$props$input2$va = _this$props$input2.value,
          value = _this$props$input2$va === void 0 ? [] : _this$props$input2$va,
          onChange = _this$props$input2.onChange;

      if (inputValue) {
        if (onChange) {
          onChange(uniq([].concat(_toConsumableArray(value), [inputValue])));
        }

        _this.setState({
          inputValue: ''
        });
      }
    }, _this.handleKeyDown = function (event) {
      var inputValue = _this.state.inputValue;
      var _this$props$input3 = _this.props.input;
      _this$props$input3 = _this$props$input3 === void 0 ? {} : _this$props$input3;
      var _this$props$input3$va = _this$props$input3.value,
          value = _this$props$input3$va === void 0 ? [] : _this$props$input3$va,
          onChange = _this$props$input3.onChange;

      switch (event.key) {
        case 'Enter':
        case 'Tab':
          if (inputValue) {
            if (onChange) {
              onChange(uniq([].concat(_toConsumableArray(value), [inputValue])));
            }

            _this.setState({
              inputValue: ''
            });

            if (event.key !== 'Tab') {
              event.preventDefault();
            }
          }

          break;

        case 'Backspace':
          // fix for backspace bug when input value and select is empty
          if (!inputValue && !value.length) {
            event.preventDefault();
          }

          break;

        default:
          break;
      }
    }, _temp));
  }

  _createClass(MultiSelect, [{
    key: "render",
    value: function render() {
      var inputValue = this.state.inputValue;
      var _this$props = this.props,
          _this$props$input4 = _this$props.input;
      _this$props$input4 = _this$props$input4 === void 0 ? {} : _this$props$input4;
      var value = _this$props$input4.value,
          placeholder = _this$props.placeholder; // react-select accept values as object in format { label, value }

      var selectedValues = (value || []).map(function (v) {
        return {
          label: v,
          value: v
        };
      });
      return React.createElement(CreatableSelect, {
        inputValue: inputValue,
        isMulti: true,
        isClearable: false,
        menuIsOpen: false,
        onChange: this.handleChange,
        onInputChange: this.handleInputChange,
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur,
        placeholder: placeholder,
        value: selectedValues,
        classNamePrefix: 'Multiselect',
        styles: this.styles,
        components: {
          DropdownIndicator: function DropdownIndicator() {
            return null;
          },
          IndicatorSeparator: function IndicatorSeparator() {
            return null;
          }
        }
      });
    }
  }]);

  return MultiSelect;
}(Component);

MultiSelect.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    onChange: PropTypes.func.isRequired
  }),
  placeholder: PropTypes.string
};
MultiSelect.defaultProps = {
  placeholder: ''
};
export default MultiSelect;